const CLIENT_ID_KEY = 'yugioh.clientId'

/**
 * Stable per-browser identity for reconnect and global chat.
 */
export function getClientId(): string {
  let id = localStorage.getItem(CLIENT_ID_KEY)
  if (!id) {
    id = 'cid_' + Math.random().toString(36).slice(2) + Date.now().toString(36)
    localStorage.setItem(CLIENT_ID_KEY, id)
  }
  return id
}
